import { Box, Flex, Grid,  Image, Text } from "@chakra-ui/react";
import { motion } from "framer-motion";
import React from "react";
import profile from '../document/satyam.png'
function About({ colorMode }) {
  return (
    <Box pt="4">
      <Box id="about" className="about section">
        <Flex justifyContent={"center"} mt="80px" position={"relative"}>
          <Box position={"absolute"} w="100%">
            <Image
              src="https://d1edzrgaei4psf.cloudfront.net/newHome/12.svg"
              opacity=".3"
              w="100%"
            />
          </Box>
          <Text
            color="orange.500"
            fontSize="22px"
            letterSpacing="20px"
            fontWeight="700"
            className="section-heading"
          >
            About
          </Text>
        </Flex>
        <br />
        <br />
        <br />
        <Grid
          w="90%"
          m="auto"
          gap={{ base: "4", md: "10" }}
          mt={{ base: "8", md: "0" }}
          gridTemplateColumns={{ base: "none", md: "1fr 2fr" }}
          gridTemplateRows={{ base: "1fr 2fr", md: "none" }}
        
        >
          <motion.div
            initial={{
              x: -200,
              opacity: 0,
            }}
            transition={{
              duration: 0.8,
            }}
            whileInView={{
              opacity: 1,
              x: 0,
            }}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Image
              className="home-img"
              src={profile}
              borderRadius="50%"
              w={{ base: "250px", md: "90%" }}
            />
          </motion.div>
          <motion.div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "0px 10px",
            }}
            initial={{
              x: -200,
              opacity: 0,
            }}
            transition={{
              duration: 0.8,
            }}
            whileInView={{
              opacity: 1,
              x: 0,
            }}
          >
            <Text
              letterSpacing={"1px"}
              as="i"
              fontWeight={"400"}
              lineHeight="2"
            >
              Hi everyone, I am
              <span id="user-detail-name">Satyam Kumar</span>
              from Lakhisarai, Bihar. Currently I am pursuing a Full-Stack Web
              Development Course from Masai School. I have completed my 12th
              (Intermediate in Science) from Rajeshwar Lal College, Lakhisarai,
              Bihar. After Completing my 12th i found myself drawn towards the
              tech world so i started to find an online platform. Once day i
              show a video about masai school on youtube and i liked the
              eduction system and support of masai school then i joined masai
              school, Which is a 7-Month long Intensive course with 1200+ hours
              of coding, DSA and hands-on Industry Relevant Skills. I'm open to
              Job opportunities. If you think my skills are relevant to your job
              requirements then do contact me. I love to work on web application
              using
              <span id="user-detail-intro">
                Frontend frameworks like React and Backend technolgies like
                NodeJS, ExpressJS and MongoDB.
              </span>
            </Text>
          </motion.div>
        </Grid>
      </Box>
      <br />
      <br />
    </Box>
  );
}

export default About;

// Hello! My name is Ankita Deb & I enjoy creating things that live on the internet. I am a Dedicated and Resposible full-stack web developer with Teamwork skills. Proficient in HTML ,CSS, JS,React.js and Redux. Curious and Eager to learn new web technologies. I'm open to Job opportunities. If you think my skills are relevant to your job requirements then do contact me.

//  <p>My name is <span id='user-detail-name'>Mayank Sharma</span>, <span id='user-detail-intro'>I am from Kolkata, India. A Passionate Full Stack Web Developer who likes developing things that dwell in the web universe. I have experience in Frontend frameworks like React and Backend technolgies like NodeJS, ExpressJS and MongoDB.</span> Skilled in problem-solving and execution of software tasks from start to finish. I look forward to joining a company where I can contribute to individual and company growth.</p>


